import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useRealtimeUnits } from 'Core/hooks';

export const useVideo = () => {
  const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });

  const clientWithVideo = useMemo(() => {
    const unitsList = Array.isArray(units) ? units : Object.values(units ?? {});
    return unitsList.some((unit) => unit?.hasVideo === true);
  }, [units]);

  return { clientWithVideo };
};
